import React, { useEffect, useState } from "react";
import { MenuItem, Menu, Button, Stack, Typography } from "@mui/material";
import BrushIcon from "@mui/icons-material/Brush";
import Infinity from "../assets/icons/Infinity";
import Email from "../assets/icons/Email";

export type ChatTypeEnum = "Email" | "Chat";

type ChatTypeModel = { name: ChatTypeEnum; icon: React.JSX.Element };
export const ChatTypes: ChatTypeModel[] = [
  {
    name: "Email",
    icon: <Email />,
  },
  {
    name: "Chat",
    icon: <Infinity />,
  },
];

const ChatType: React.FC<{ handleTypeChange: (type: ChatTypeEnum) => void; value?: ChatTypeEnum }> = ({
  handleTypeChange,
  value,
}) => {
  const [selectedType, setSelectedType] = useState<ChatTypeModel>(ChatTypes[0]);

  useEffect(() => {
    if (!value) return;
    const type = ChatTypes.find((chatType) => chatType.name === value);
    if (type) {
      setSelectedType(type);
    }
  }, [value]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectType = (type: ChatTypeModel) => {
    setSelectedType(type);
    setAnchorEl(null);
    handleTypeChange(type.name);
  };

  return (
    <>
      <Button size="small" onClick={handleClick} variant="outlined" color="inherit" startIcon={selectedType.icon}>
        {selectedType.name}
      </Button>
      <Menu
        id="user-tone-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "user-tone-button",
          role: "listbox",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {ChatTypes.map((type) => (
          <MenuItem key={type.name} onClick={() => handleSelectType(type)}>
            <Stack direction="row" spacing={1} alignItems="center">
              {type.icon}
              <Typography variant="body2">{type.name}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ChatType;
